import WorkerRunsTablePanel from "#src/batteries-included-components/Panels/TablePanels/WorkerRunsTablePanel/WorkerRunsTablePanel";
import { useIsFeatureAvailable } from "#src/contexts/AuthenticatedContext.helpers";
import { useRunWorkerDrawer } from "#src/contexts/RunWorkerDrawer";
import { useStorageKey } from "#src/hooks/useStorageKey";
import { useBreadcrumbsFromRoute } from "#src/utils/route";
import { Button, Icon, Page } from "@validereinc/common-components";
import { FeatureFlags, PermissionsMap } from "@validereinc/domain-controllers";
import React from "react";
import { WorkerLogsRoutePath } from ".";

/**
 * Worker Run Log page under Data Tools. Displays worker runs in a data table.
 */
export const WorkerLogsPage = () => {
  const [breadcrumbs] = useBreadcrumbsFromRoute(WorkerLogsRoutePath);
  const [filterConfigStorageKey, tableConfigStorageKey, tableStateStorageKey] =
    useStorageKey(
      ["filter-configuration", "table-configuration", "table-state"],
      "worker-logs"
    );

  const [hasWorkerRunWritePermission] = useIsFeatureAvailable({
    featureFlagQuery: FeatureFlags.CustomCodeFeatureFlag,
    permissionQuery: PermissionsMap.WorkerRunWrite,
  });
  const { setIsOpen: setRunWorkerDrawerIsOpen, resetSelection } =
    useRunWorkerDrawer();

  return (
    <Page
      title={WorkerLogsRoutePath.title}
      breadcrumbs={breadcrumbs}
      actionRow={[
        ...(hasWorkerRunWritePermission
          ? [
              <Button
                key="run-worker"
                variant="primary"
                onClick={() => {
                  resetSelection();
                  setRunWorkerDrawerIsOpen(true);
                }}
                slotLeft={
                  <Icon
                    variant="plus-circle"
                    size={24}
                  />
                }
                size="small"
              >
                Run Worker
              </Button>,
            ]
          : []),
      ]}
    >
      <WorkerRunsTablePanel
        tableConfigStorageKey={tableConfigStorageKey}
        filterConfigStorageKey={filterConfigStorageKey}
        tableStateStorageKey={tableStateStorageKey}
      />
    </Page>
  );
};
